/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import React from 'react'

import { getTotalCost } from '@common/functions'
import { SVGChevronDown } from '@common/public/assets'
import useNetwork from '@hooks/useNetwork'

import { DropDownContainer, DropDownHeader, DropDownList, DropDownListContainer, ListItem } from './styles'

interface ISelectedOptionProperties {
    mintPrice: string
    maxPerTransaction: number
    selectedOption: number
    setSelectedOption: React.Dispatch<React.SetStateAction<number>>
    suggestedGasFees: string
    setEstimatedTotalCost: React.Dispatch<React.SetStateAction<string>>
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    id?: string
}

const SelectQuantity: React.FC<ISelectedOptionProperties> = ({
    selectedOption,
    maxPerTransaction,
    mintPrice,
    suggestedGasFees,
    id,
    setSelectedOption,
    setEstimatedTotalCost,
}) => {
    const [isOpen, setIsOpen] = React.useState(false)
    const {
        operations: { handleMintPriceChange },
    } = useNetwork()

    React.useEffect(() => {
        handleMintPriceChange()
    }, [selectedOption])

    React.useEffect(() => {
        selectedOption > maxPerTransaction && setSelectedOption(maxPerTransaction)
        selectedOption < 1 && setSelectedOption(1)
    }, [maxPerTransaction, selectedOption, setSelectedOption])

    React.useEffect(() => {
        setTimeout(async () => {
            setEstimatedTotalCost(getTotalCost(mintPrice, suggestedGasFees))
        }, 1)
    }, [mintPrice, selectedOption, setEstimatedTotalCost, suggestedGasFees])

    const toggling = () => setIsOpen(!isOpen)

    const maxPerWalletArray = []

    for (let index = 0; index < maxPerTransaction; index++) {
        maxPerWalletArray.push(index + 1)
    }

    const onOptionClicked = (value: React.SetStateAction<number>) => () => {
        setSelectedOption(value)
        setIsOpen(false)
    }
    React.useEffect(() => {
        document.addEventListener('click', event => {
            const selectedContainer = document.querySelector('#select-quantity-dropdown')
            const selectedButtonDrop = document.querySelectorAll('#select-quantity-dropdown > *')
            if (
                event.target !== selectedButtonDrop[0] &&
                event.target !== selectedButtonDrop[1] &&
                event.target !== selectedContainer
            ) {
                setIsOpen(false)
            }
        })
    }, [])

    return (
        <div>
            <DropDownContainer>
                <DropDownHeader onClick={toggling} id="select-quantity-dropdown">
                    <span id={id}>Mint {selectedOption}</span> <SVGChevronDown />
                </DropDownHeader>
                {isOpen && (
                    <DropDownListContainer>
                        <DropDownList>
                            {maxPerWalletArray.map(option => (
                                <ListItem onClick={onOptionClicked(option)} key={Math.random()}>
                                    <p>Mint {option}</p>
                                </ListItem>
                            ))}
                        </DropDownList>
                    </DropDownListContainer>
                )}
            </DropDownContainer>
        </div>
    )
}

export default SelectQuantity
